import { PopoverContainer } from '../../../pages/claimForms/components/PopoverContainer';
import { LabelContainer, LabelTitle } from './styled';

type LabelProps = {
  title?: string;
  description?: string;
  id?: string;
};

export const Label = ({ title, description, id }: LabelProps) => {
  return (
    <LabelContainer>
      <LabelTitle>{title}</LabelTitle>
      {description && <PopoverContainer id={id} description={description} />}
    </LabelContainer>
  );
};
